// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Modal$OrcaPaymentPage from "./Modal.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";

function ClickToPayLearnMore(props) {
  let match = React.useState(() => false);
  let setOpenModal = match[1];
  let match$1 = React.useState(() => "");
  let setCardBrand = match$1[1];
  let cardBrand = match$1[0];
  let logger = HyperLogger$OrcaPaymentPage.make(undefined, {
    TAG: "Elements",
    _0: "Payment"
  }, undefined, undefined, undefined);
  let closeClickToPayModal = () => {
    setOpenModal(param => false);
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "fullscreen",
        false
      ]]);
  };
  React.useEffect(() => {
    ClickToPayHelpers$OrcaPaymentPage.loadClickToPayScripts(logger);
    let handle = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
        return;
      }
      let metadata = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata"));
      let cardBrands = Utils$OrcaPaymentPage.getArray(metadata, "cardBrands").map(x => Core__Option.getOr(Core__JSON.Decode.string(x), "")).filter(x => x !== "").join(",");
      if (cardBrands === "") {
        closeClickToPayModal();
      }
      setCardBrand(param => cardBrands);
    };
    window.addEventListener("message", handle);
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  React.useEffect(() => {
    let handleClickToPayLearnMore = param => closeClickToPayModal();
    window.addEventListener("ok", handleClickToPayLearnMore);
    return () => {
      window.removeEventListener("ok", handleClickToPayLearnMore);
    };
  }, []);
  return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
    condition: cardBrand !== "",
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Modal$OrcaPaymentPage.make, {
        children: JsxRuntime.jsx(prim => React.createElement("src-learn-more", prim), {
          "card-brands": cardBrand
        }),
        showClose: false,
        setOpenModal: setOpenModal,
        openModal: match[0]
      })
    })
  });
}

let make = ClickToPayLearnMore;

export {
  make,
}
/* react Not a pure module */
